/**
 * Object.entries : converting ES6 Object.entries in ES5
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */

if (!Object.entries) {
    Object.entries = function (obj) {
        const ownProps = Object.keys(obj), resArray = new Array(i);
        let i = ownProps.length;
        while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];
        return resArray;
    };
}

/**
 * String.prototype.includes : if includes function not found for string in Browser
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        if (typeof start !== 'number') start = 0;
        if (start + search.length > this.length) return false;
        else return this.indexOf(search, start) !== -1;
    };
}

/**
 * Array.includes : if includes function not found for array in Browser
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, "includes", {
        enumerable: false,
        value: function(obj) {
            const newArr = this.filter(function(el) {
                return el === obj;
            });
            return newArr.length > 0;
        }
    });
}


/**
 * Object.assign : overriding Object.assign function
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */

if (typeof Object.assign != 'function') {
    Object.assign = function(target) {
        'use strict';
        if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (let index = 1; index < arguments.length; index++) {
            const source = arguments[index];
            if (source != null) {
                for (let key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };
}

/**
 * Object.values : overriding Object.values function
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */

if (typeof Object.values != 'function') {
    Object.values = function(target) {
        return Object.keys(target).map(key => target[key])
    };
}

/**
 * Number.prototype.toFixed : overriding Number.prototype.toFixed function with rounding type up
 * 
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */
